/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/*
 *
 * Action types for Verifications.
 *
 */

import { ReduxUtils } from '@spm/core';

const POST_VERIFICATIONS_CREATE_CASEWORKER_TASK = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `VERIFICATIONS/POST_VERIFICATIONS_CREATE_CASEWORKER_TASK`
);

const POST_VERIFICATIONS_LINK_FILE = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `VERIFICATIONS/POST_VERIFICATIONS_LINK_FILE`
);

const DELETE_VERIFICATIONS_FILE_LINKS_BY_LINK_ID = ReduxUtils.generateActionTypes(
  'ua-library',
  `VERIFICATIONS/DELETE_VERIFICATIONS_FILE_LINKS_BY_LINK_ID`,
  'DELETE'
);

const FETCH_VERIFICATIONS = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `VERIFICATIONS/FETCH_VERIFICATIONS`
);

const GET_VERIFICATIONS_BY_VERIFICATION_ID = ReduxUtils.generateFetchActionTypes(
  'ua-library',
  `VERIFICATIONS/GET_VERIFICATIONS_BY_VERIFICATION_ID`
);

const POST_VERIFICATIONS_SD_CREATE_CASEWORKER_TASK = ReduxUtils.generatePostActionTypes(
  'ua-library',
  `VERIFICATIONS/POST_VERIFICATIONS_SD_CREATE_CASEWORKER_TASK`
);

export {
  POST_VERIFICATIONS_CREATE_CASEWORKER_TASK,
  POST_VERIFICATIONS_LINK_FILE,
  DELETE_VERIFICATIONS_FILE_LINKS_BY_LINK_ID,
  FETCH_VERIFICATIONS,
  GET_VERIFICATIONS_BY_VERIFICATION_ID,
  POST_VERIFICATIONS_SD_CREATE_CASEWORKER_TASK,
};
